import { render, staticRenderFns } from "./SelfSelect.vue?vue&type=template&id=10e54b3c&scoped=true"
import script from "./SelfSelect.vue?vue&type=script&lang=js"
export * from "./SelfSelect.vue?vue&type=script&lang=js"
import style0 from "./SelfSelect.vue?vue&type=style&index=0&id=10e54b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e54b3c",
  null
  
)

export default component.exports